import { useEffect, useState } from "react";
import { getBackups, LegacyBackupRecord } from "./store/admin.api";

const formatCreatedAt = (value: string) => {
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? date.toUTCString() : "Unknown";
};

export const DBBackupPage = () => {
    const [records, setRecords] = useState<LegacyBackupRecord[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let active = true;

        (async () => {
            try {
                const result = await getBackups();
                if (active) setRecords(result.data.items);
            } catch (requestError) {
                if (active) {
                    setError(requestError instanceof Error
                        ? requestError.message
                        : "Legacy export records are unavailable");
                }
            } finally {
                if (active) setLoading(false);
            }
        })();

        return () => {
            active = false;
        };
    }, []);

    return (
        <div className="container-fluid py-3">
            <div className="mb-4">
                <h2 className="h4 mb-2">Legacy database exports</h2>
                <p className="text-light mb-0">
                    These records are historical logical-export metadata. They do not represent current backup health or recovery readiness.
                </p>
            </div>

            {loading && <p className="text-muted">Loading legacy export records...</p>}
            {!loading && error && <div className="alert alert-danger" role="alert">{error}</div>}
            {!loading && !error && records.length === 0 && (
                <p className="text-muted">No legacy export records found.</p>
            )}

            {!loading && !error && records.length > 0 && (
                <div className="table-responsive">
                    <table className="table table-dark table-striped align-middle">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Name</th>
                                <th scope="col">Created</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((record, index) => (
                                <tr key={record.id}>
                                    <td>{index + 1}</td>
                                    <td>{record.name || "Unnamed legacy export"}</td>
                                    <td>{formatCreatedAt(record.createdAt)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
